// import React, { useEffect, useState, useContext } from "react";
// import {
//     Box, Typography, Grid, Card, CardContent, Paper, TextField,
//     Button, Stack, Divider,
//     CircularProgress
// } from "@mui/material";
// import { Line, Doughnut, Bar } from "react-chartjs-2";
// import {
//     Chart as ChartJS, ArcElement, Tooltip, Legend, CategoryScale,
//     LinearScale, LineElement, BarElement, PointElement
// } from "chart.js";
// import { Upload } from "@mui/icons-material";
// import dayjs from "dayjs";
// import axios from "axios";
// import apiUrl from "../../Config";


// ChartJS.register(ArcElement, Tooltip, Legend, CategoryScale, LinearScale, LineElement, BarElement, PointElement);


// const Dashboard = () => {
//     const [dashboard, setDashboard] = useState([]);
//     const [fromDate, setFromDate] = useState("");
//     const [toDate, setToDate] = useState("");
//     const [loading, setLoading] = useState(false)
//     const [error, setError] = useState("")

//     useEffect(() => {
//         const fetchData = async () => {
//             setLoading(true)
//             try {
//                 const res = await axios.get(`${apiUrl}/dashboard/getdashboard?fromDate=${fromDate}&toDate=${toDate}`);

//                 setDashboard(res.data);
//             } catch (error) {
//                 console.error("Failed to fetch dashboard data:", error);
//                 const message = error?.response?.data?.message || error.message || 'Failed to fetch dashboard'
//                 setError(message)
//             } finally {
//                 setLoading(false)
//             }
//         };
//         fetchData();
//     }, []);



//     const salesData = dashboard?.monthlyBookings || [];
//     const lineData = {
//         labels: salesData.map(m => m.month),
//         datasets: [{
//             label: "Monthly Orders",
//             data: salesData.map(m => m.bookings),
//             borderColor: "#3b82f6",
//             backgroundColor: "rgba(59, 130, 246, 0.2)",
//             fill: true
//         }]
//     };

//     const todayOrderData = {
//         labels: ["Success", "Pending", "Cancelled", "Confirmed", "Completed"],
//         datasets: [{
//             label: "Today's Orders",
//             data: [
//                 dashboard?.bookingSummary?.range?.success || 0,
//                 dashboard?.bookingSummary?.range?.pending || 0,
//                 dashboard?.bookingSummary?.range?.cancel || 0,
//                 dashboard?.bookingSummary?.range?.completed || 0,
//                 dashboard?.bookingSummary?.range?.confirmed || 0
//             ],
//             backgroundColor: ["#10b981", "#fbbf24", "#ef4444", "#3b82f6", "#8b5cf6"]
//         }]
//     };

//     const yearlyOrders = dashboard?.bookingSummary?.yearlyBookings?.currentYear || {};

//     const yearlyChart = {
//         labels: ["Success", "Pending", "Confirmed", "Cancelled", "Completed", "Total"],
//         datasets: [{
//             label: "Yearly Orders",
//             data: [
//                 yearlyOrders.success || 0,
//                 yearlyOrders.pending || 0,
//                 yearlyOrders.confirmed || 0,
//                 yearlyOrders.cancel || 0,
//                 yearlyOrders.completed || 0,
//                 yearlyOrders.total || 0
//             ],
//             backgroundColor: [
//                 "#10b981", "#fbbf24", "#3b82f6", "#ef4444", "#8b5cf6", "#6b7280"
//             ]
//         }]
//     };


//     const handleSearch = async () => {
//         setLoading(true)
//         try {
//             const res = await axios.get(`${apiUrl}/dashboard/getdashboard?fromDate=${fromDate}&toDate=${toDate}`);

//             setDashboard(res.data);
//         } catch (err) {
//             console.error("Failed to fetch dashboard data:", err);
//         } finally {
//             setLoading(false)
//         }
//     };
//     const today = dayjs().format("YYYY-MM-DD");


//     return (
//         <Box sx={{ p: 3 }}>
//             <Box mb={3} mt={1.4}>
//                 <Stack
//                     direction={{ xs: 'column', sm: 'row' }}
//                     justifyContent="space-between"
//                     alignItems={{ xs: 'flex-start', sm: 'center' }}
//                     spacing={2}
//                     flexWrap="wrap"
//                 >
//                     <Typography variant="h5">Dashboard</Typography>

//                     <Stack direction="row" gap={2} flexWrap="wrap">
//                         <TextField
//                             type="date"
//                             value={fromDate}
//                             label="From"
//                             size="small"
//                             width='70px'
//                             InputLabelProps={{ shrink: true }}
//                             inputProps={{ max: today }}
//                             onChange={(e) => setFromDate(e.target.value)}
//                         />
//                         <TextField
//                             type="date"
//                             value={toDate}
//                             label="To"
//                             size="small"
//                             InputLabelProps={{ shrink: true }}
//                             inputProps={{ max: today }}
//                             onChange={(e) => setToDate(e.target.value)}
//                         />
//                         <Button
//                             variant="contained"
//                             onClick={handleSearch}
//                             disabled={loading}
//                             startIcon={loading ? <CircularProgress size={20} color="inherit" /> : null}
//                         >
//                             {loading ? 'Searching...' : 'Search'}
//                         </Button>
//                         {/* <Button variant="contained" startIcon={<Upload />}>
//                             Export
//                         </Button> */}
//                     </Stack>
//                 </Stack>
//             </Box>

//             {loading ? (
//                 <Box display="flex" justifyContent="center" alignItems="center" height={200}>
//                     <CircularProgress />
//                 </Box>
//             ) : (
//                 <>
//                     <Grid container spacing={2}>
//                         {[{
//                             title: "Total Revenue", value: `₹ ${dashboard?.totalEarnings || "0.00"}`
//                         }, {
//                             title: "Total Customers", value: dashboard?.userStats?.total || 0
//                         }, {
//                             title: "Active Products", value: dashboard?.totalBooks?.active || 0
//                         }, {
//                             title: <Typography variant="body1" fontWeight={500}>
//                                 {fromDate && toDate ? "Selected Range Orders" : "Today's Orders"}
//                             </Typography>, value: dashboard?.bookingSummary?.range?.total || 0
//                         }].map((card, i) => (
//                             <Grid size={{ xs: 12, sm: 6, md: 3 }} key={i}>
//                                 <Card sx={{ p: 2, border: "1px solid #ccc", borderRadius: 2 }}>
//                                     <CardContent>
//                                         <Typography variant="subtitle2" color="text.secondary">{card.title}</Typography>
//                                         <Typography variant="h5">{card.value}</Typography>
//                                     </CardContent>
//                                 </Card>
//                             </Grid>
//                         ))}
//                     </Grid>

//                     <Grid container spacing={2} mt={2}>
//                         <Grid size={{ xs: 12, md: 6 }}>
//                             <Paper sx={{ p: 2, border: "1px solid #ccc" }}>
//                                 <Typography variant="subtitle1" fontWeight={600} mb={2}>Monthly Sales</Typography>
//                                 <Line data={lineData} />
//                             </Paper>
//                         </Grid>
//                         <Grid size={{ xs: 12, md: 6 }}>
//                             <Paper sx={{ p: 2, border: "1px solid #ccc" }}>
//                                 <Typography variant="subtitle1" fontWeight={600} mb={2}>Today's Orders Breakdown</Typography>
//                                 <Bar data={todayOrderData} />
//                             </Paper>
//                         </Grid>
//                     </Grid>

//                     <Grid container spacing={2} mt={2}>
//                         <Grid size={{ xs: 12, md: 6 }} >
//                             <Paper sx={{ p: 2, border: "1px solid #ccc", display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
//                                 <Typography variant="subtitle1" fontWeight={600} mb={2}>Yearly Orders Summary</Typography>
//                                 <Box sx={{ width: '300px', height: '300px' }}>
//                                     <Doughnut data={yearlyChart} />
//                                 </Box>
//                             </Paper>
//                         </Grid>
//                         <Grid size={{ xs: 12, md: 6 }}>
//                             <Paper sx={{ p: 2, border: "1px solid #ccc" }}>
//                                 <Typography variant="subtitle1" fontWeight={600} mb={2}>Weekly Customers</Typography>
//                                 <Stack spacing={1} divider={<Divider />}>
//                                     <Typography>This Week: {dashboard?.userStats?.thisWeek || 0}</Typography>
//                                     <Typography>Last Week: {dashboard?.userStats?.lastWeek || 0}</Typography>
//                                 </Stack>
//                             </Paper>
//                         </Grid>
//                     </Grid>
//                 </>
//             )}

//             {error && (
//                 <Typography color="error" variant="body2" sx={{ mb: 2 }}>
//                     {error}
//                 </Typography>
//             )}
//         </Box>
//     );
// };

// export default Dashboard;







import React, { useEffect, useState } from "react";
import {
  Box, Typography, Grid, Card, CardContent, Paper, TextField,
  Button, Stack, Divider,
  CircularProgress
} from "@mui/material";
import { Line, Doughnut, Bar } from "react-chartjs-2";
import {
  Chart as ChartJS, ArcElement, Tooltip, Legend, CategoryScale,
  LinearScale, LineElement, BarElement, PointElement
} from "chart.js";
import dayjs from "dayjs";
import axios from "axios";
import apiUrl from "../../Config";
import { useNavigate } from "react-router-dom";

ChartJS.register(ArcElement, Tooltip, Legend, CategoryScale, LinearScale, LineElement, BarElement, PointElement);

const Dashboard = () => {
  const [dashboard, setDashboard] = useState([]);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const res = await axios.get(`${apiUrl}/dashboard/getdashboard?fromDate=${fromDate}&toDate=${toDate}`);
        setDashboard(res.data);
      } catch (error) {
        console.error("Failed to fetch dashboard data:", error);
        const message = error?.response?.data?.message || error.message || 'Failed to fetch dashboard';
        setError(message);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  const salesData = dashboard?.monthlyBookings || [];
  const lineData = {
    labels: salesData.map(m => m.month),
    datasets: [{
      label: "Monthly Orders",
      data: salesData.map(m => m.bookings),
      borderColor: "#3b82f6",
      backgroundColor: "rgba(59, 130, 246, 0.2)",
      fill: true
    }]
  };

  const todayOrderData = {
    labels: ["Pending", "Order Confirmed", "Delivery Transit", "Order Delivered", "Cancelled"],
    datasets: [{
      label: "Today's Orders",
      data: [
        dashboard?.bookingSummary?.range?.pending || 0,
        dashboard?.bookingSummary?.range?.orderConfirmed || 0,
        dashboard?.bookingSummary?.range?.deliveryTransit || 0,
        dashboard?.bookingSummary?.range?.orderDelivered || 0,
        dashboard?.bookingSummary?.range?.cancelled || 0
      ],
      backgroundColor: ["#10b981", "#fbbf24", "#ef4444", "#3b82f6", "#8b5cf6"]
    }]
  };

  const yearlyOrders = dashboard?.bookingSummary?.yearlyBookings?.currentYear || {};

  const yearlyChart = {
    labels: ["Pending", "Order Confirmed", "Delivery Transit", "Order Delivered", "Cancelled", "Total"],
    datasets: [{
      label: "Yearly Orders",
      data: [
        yearlyOrders.pending || 0,
        yearlyOrders.orderConfirmed || 0,
        yearlyOrders.deliveryTransit || 0,
        yearlyOrders.orderDelivered || 0,
        yearlyOrders.cancelled || 0,
        yearlyOrders.total || 0
      ],
      backgroundColor: [
        "#10b981", "#fbbf24", "#3b82f6", "#ef4444", "#8b5cf6", "#6b7280"
      ]
    }]
  };

  const handleSearch = async () => {
    setLoading(true);
    try {
      const res = await axios.get(`${apiUrl}/dashboard/getdashboard?fromDate=${fromDate}&toDate=${toDate}`);
      setDashboard(res.data);
    } catch (err) {
      console.error("Failed to fetch dashboard data:", err);
      const message = err?.response?.data?.message || err.message || 'Failed to fetch dashboard';
      setError(message);
    } finally {
      setLoading(false);
    }
  };

  const today = dayjs().format("YYYY-MM-DD");

  const cards = [
    { title: "Total Revenue", value: `₹ ${dashboard?.totalEarnings || "0.00"}`, path: "/revenuedetails" },
    { title: "Total Customers", value: dashboard?.userStats?.total || 0, path: "/users" },
    { title: "Active Products", value: dashboard?.totalBooks?.active || 0, path: "/" },
    {
      title: <Typography variant="body1" fontWeight={500}>
        {fromDate && toDate ? "Selected Range Orders" : "Today's Orders"}
      </Typography>,
      value: dashboard?.bookingSummary?.range?.total || 0,
      path: "/"
    }
  ];

  return (
    <Box sx={{ p: 3 }}>
      <Box mb={3} mt={1.4}>
        <Stack
          direction={{ xs: 'column', sm: 'row' }}
          justifyContent="space-between"
          alignItems={{ xs: 'flex-start', sm: 'center' }}
          spacing={2}
          flexWrap="wrap"
        >
          <Typography variant="h5">Dashboard</Typography>

          <Stack direction="row" gap={2} flexWrap="wrap">
            <TextField
              type="date"
              value={fromDate}
              label="From"
              size="small"
              width='70px'
              InputLabelProps={{ shrink: true }}
              inputProps={{ max: today }}
              onChange={(e) => setFromDate(e.target.value)}
            />
            <TextField
              type="date"
              value={toDate}
              label="To"
              size="small"
              InputLabelProps={{ shrink: true }}
              inputProps={{ max: today }}
              onChange={(e) => setToDate(e.target.value)}
            />
            <Button
              variant="contained"
              onClick={handleSearch}
              disabled={loading}
              startIcon={loading ? <CircularProgress size={20} color="inherit" /> : null}
            >
              {loading ? 'Searching...' : 'Search'}
            </Button>
          </Stack>
        </Stack>
      </Box>

      {loading ? (
        <Box display="flex" justifyContent="center" alignItems="center" height={200}>
          <CircularProgress />
        </Box>
      ) : (
        <>
          <Grid container spacing={2}>
            {cards.map((card, i) => (
              <Grid item size ={{xs:12,sm:6,md:3}} key={i}>
                <Card
                  sx={{ p: 2, border: "1px solid #ccc", borderRadius: 2, cursor: "pointer" }}
                onClick={() => navigate(card.path, { state: { fromDate, toDate, } })}
                  role="button"
                  tabIndex={0}
                   onKeyPress={e => { if (e.key === 'Enter') navigate(card.path, { state: { fromDate, toDate, } }) }}
                >
                  <CardContent>
                    <Typography variant="subtitle2" color="text.secondary">{card.title}</Typography>
                    <Typography variant="h5">{card.value}</Typography>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>

          <Grid container spacing={2} mt={2}>
            <Grid item size ={{xs:12,md:6}}>
              <Paper sx={{ p: 2, border: "1px solid #ccc" }}>
                <Typography variant="subtitle1" fontWeight={600} mb={2}>Monthly Sales</Typography>
                <Line data={lineData} />
              </Paper>
            </Grid>
            <Grid item size ={{xs:12,md:6}}>
              <Paper sx={{ p: 2, border: "1px solid #ccc" }}>
                <Typography variant="subtitle1" fontWeight={600} mb={2}>Today's Orders Breakdown</Typography>
                <Bar data={todayOrderData} />
              </Paper>
            </Grid>
          </Grid>

          <Grid container spacing={2} mt={2}>
            <Grid item size ={{xs:12,md:6}} >
              <Paper sx={{ p: 2, border: "1px solid #ccc", display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <Typography variant="subtitle1" fontWeight={600} mb={2}>Yearly Orders Summary</Typography>
                <Box sx={{ width: '300px', height: '300px' }}>
                  <Doughnut data={yearlyChart} />
                </Box>
              </Paper>
            </Grid>
            <Grid item size ={{xs:12,md:6}}>
              <Paper sx={{ p: 2, border: "1px solid #ccc" }}>
                <Typography variant="subtitle1" fontWeight={600} mb={2}>Weekly Customers</Typography>
                <Stack spacing={1} divider={<Divider />}>
                  <Typography>This Week: {dashboard?.userStats?.thisWeek || 0}</Typography>
                  <Typography>Last Week: {dashboard?.userStats?.lastWeek || 0}</Typography>
                </Stack>
              </Paper>
            </Grid>
          </Grid>
        </>
      )}

      {error && (
        <Typography color="error" variant="body2" sx={{ mb: 2 }}>
          {error}
        </Typography>
      )}
    </Box>
  );
};

export default Dashboard;
